export default "__VITE_ASSET__2580c435__"